export enum CustomShippingCarrierKindEnum {
  Other = 'other',
  WillPickup = 'will-pickup',
}
